import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Ticket } from "lucide-react";
 * // Use <Ticket /> instead
 */
export const VouchersIcon = createSVGWrapper(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M6 3C6 2.448 6.449 2 7 2h2.17a3.001 3.001 0 0 0 5.658 0H17c.552 0 1 .448 1 1v18c0 .552-.448 1-1 1h-2.17a3.001 3.001 0 0 0-5.658 0H7A1.001 1.001 0 0 1 6 21V3Zm9.814 6.085a.636.636 0 0 0-.9-.899l-6.728 6.729a.636.636 0 0 0 .899.899l6.729-6.729Zm-5.272.186a1.271 1.271 0 1 1-2.542 0 1.271 1.271 0 0 1 2.542 0ZM14.73 16a1.271 1.271 0 1 0 0-2.543 1.271 1.271 0 0 0 0 2.543Z"
    clipRule="evenodd"
  />
);
